import ZtServiceFactory from '@src/services/zt';

// 后端用 -20142 表示"暂无可召回好友列表"，与成功空列表同义（2026-09-24 门控需求）
const EMPTY_RECALL_LIST_CODE = -20142;

function getZtService() {
  return ZtServiceFactory.getDefaultInstance();
}

/**
 * Loads recallable friends as view-ready records.
 * @param {Object} options Adapter dependencies.
 * @param {Function} options.provider Optional raw recall-list provider for unit tests.
 * @returns {Promise<Array>} Recall friend ViewModels.
 */
export function loadRecallFriends(options = {}) {
  const provider = options.provider || (mockPassportAccount => getZtService().getRecallList(mockPassportAccount));

  return Promise.resolve()
    .then(() => provider(undefined))
    .then(response =>
      response.recall_list.map(friend => ({
        relationType: friend.relation_type || '',
        relationText: friend.relation || '',
        roleName: friend.role_name || '',
        invited: friend.has_sent_sms === 1
      }))
    )
    .catch(error => {
      // 工厂会把 -20142 转为 ServiceResponseError；归一化为空列表交给弹窗门控分流，其余错误原样传播
      if (error && error.serviceResponse && error.serviceResponse.code === EMPTY_RECALL_LIST_CODE) {
        return [];
      }

      throw error;
    });
}

/**
 * Sends one friend recall request by its backend relation identifier.
 * @param {string} relationType Relation identifier returned by the recall list.
 * @param {Object} options Adapter dependencies.
 * @param {Function} options.provider Optional recall mutation provider for unit tests.
 * @returns {Promise<void>} Resolves when the request succeeds.
 */
export function recallFriend(relationType, options = {}) {
  const provider = options.provider || ((mockPassportAccount, targetRelationType) => getZtService().recallFriend(mockPassportAccount, targetRelationType));

  return Promise.resolve()
    .then(() => provider(undefined, relationType))
    .then(() => undefined);
}

export default {
  loadRecallFriends,
  recallFriend
};
